module.exports = __webpack_public_path__ + "img/ztgy-hlydl.c0602bde.png";